import axios from 'axios';

const translateText = async (text, targetLang) => {
  const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATOR; // Replace with your Google API Key
  const url = `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`;

  //const translateUrl = `https://translation.googleapis.com/language/translate/v2/detect?key=${apiKey}`;

  try {

    // const detectResponse = await axios.post(translateUrl, {
    //   q: text,
    //   target: targetLang,
    // });

    // const detectedLang = detectResponse.data.data.detections[0][0].language;

    let payload = {
      q: text,
      target: targetLang
    };

    // // Add source only when source and target languages are different
    // const Lang = detectedLang === "en" ? "en" : "es";
    // if (targetLang !== Lang) {
    //   payload.source = detectedLang === "en" ? "en" : "es";
    // }

    const response = await axios.post(url, payload);


    if (Array.isArray(text)) {
      if (text.length >= 1) {
        return response.data.data.translations.map(item => item.translatedText);
      }
    }

    return response.data.data.translations[0].translatedText;

  } catch (error) {
    console.error("Translation Error: ", error);
    return text;
  }
};

export default translateText;
